<template>
  <div
    :class="[
      'overflow-hidden shadow',
      mobileFullWidth ? 'sm:rounded-lg' : 'rounded-lg',
      colorShade,
    ]"
  >
    <div
      v-if="$slots.header"
      class=""
      :class="[headerStyling, headerColorShade, headerBorderColor]"
    >
      <slot name="header" />
    </div>
    <div :class="baseStyling">
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      :class="[footerStyling, footerColorShade, footerBorderColor]"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobileFullWidth: { type: Boolean, default: false },

    colorShade: { type: String, default: "bg-white" },

    headerColorShade: { type: String, default: "bg-white" },

    footerColorShade: { type: String, default: "bg-white" },

    headerBorderColor: { type: String, default: "border-gray-200" },

    footerBorderColor: { type: String, default: "border-gray-200" },

    baseStyling: { type: String, default: "px-4 py-5 sm:p-6 w-full" },

    headerStyling: { type: String, default: "border-b px-4 py-5 sm:px-6" },

    footerStyling: { type: String, default: "border-t px-4 py-4 sm:px-6" },
  },
};
</script>
